/* eslint-disable camelcase */
export default {
  title: "Перевод на кошелек youzan",
  button_reset: 'Сброс',
  label_src_balance: "Баланс",
  label_dst_balance: "Баланс Youzan",
  label_debit_amount: "Сумма списания",
  error_not_number: "Сумма должна быть числом",
  error_amount_required: "Требуется указать сумму",
  transfer_success: "Перевод успешно выполнен",
  button_transfer_to_youzan: "Перевести на youzan",
  button_transfer_from_youzan: "Перевести c youzan",
};
